var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"group-sport-header__footer",attrs:{"title":_vm.props.content}},[_vm._v("\n    "+_vm._s(_vm.props.content)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518fcc8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/terminal/app/modules/eventGrid/components/SectionFooterRow.vue
// module id = 1966
// module chunks = 0